import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';

// Your web app's Firebase configuration
// IMPORTANT: Replace these with your actual Firebase project config values
const firebaseConfig = {
  apiKey: "AIzaSyBi6MgZob8p76keNHxRnH1Z6gtQjirKhLk",
  authDomain: "vishal-prompt-402ce.firebaseapp.com",
  projectId: "vishal-prompt-402ce",
  storageBucket: "vishal-prompt-402ce.firebasestorage.app",
  messagingSenderId: "348920690798",
  appId: "1:348920690798:web:f84831d1df9594a5ea0e7f",
  measurementId: "G-DS157Y257Y"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
